import { ActionType, EventType, useTrackComponent } from 'opensolar-common'
import { styled } from 'opensolar-ui'
import { ChipsArrayInput, ReferenceArrayInput } from 'react-admin'
import { Field } from 'react-final-form'
import { ResourcePrefix } from './controller/UploadFileContext'

export const trackTagChanges = ({ addedTags, removedTags, findItemsInChoices, trackEvent }) => {
  if (addedTags.length > 0) {
    const addedItems = findItemsInChoices(addedTags)
    trackEvent(
      EventType.USER_INTERACTION,
      { type: ActionType.EDIT },
      { eventName: 'User Added File Tag', tags: addedItems }
    )
  }

  if (removedTags.length > 0) {
    const removedItems = findItemsInChoices(removedTags)
    trackEvent(
      EventType.USER_INTERACTION,
      { type: ActionType.EDIT },
      {
        eventName: 'User Removed File Tag',
        tags: removedItems.map((item, index) => (item ? item.title : removedTags[index])),
      }
    )
  }
}

const ChipsInputContainer = styled('div')(({ theme }) => ({
  '& .OSUI-TextField-root': {
    boxSizing: 'border-box',
    width: '100%',
    '& >div:first-of-type': {
      padding: 12,
      '& >div:first-of-type': {
        padding: 0,
        display: 'flex',
        flexFlow: 'row wrap',
        columnGap: 8,
        rowGap: 8,
      },
    },
  },
  '& .OSUI-Chip-root': {
    whiteSpace: 'normal',
    boxSizing: 'content-box',
    minHeight: 'fit-content',
    height: 'fit-content',
  },
  '& .OSUI-Chip-label': {
    height: 'fit-content',
    whiteSpace: 'normal',
    minHeight: 'fit-content',
    textOverflow: 'initial',
    marginRight: 5,
    marginTop: 2,
  },
}))

type PropsType = {
  /** 'global_public' uses same file tags as 'public'; API only accepts 'private' | 'public' */
  resource_prefix?: ResourcePrefix
  disabled?: boolean
}

export const FileTagsChipsInput = ({ resource_prefix = 'private', disabled }: PropsType) => {
  const { trackEvent } = useTrackComponent({
    componentKey: 'chip_array_input',
    eventName: 'User Updated File Tags',
  })

  const tagType = resource_prefix === 'global_public' ? 'public' : resource_prefix
  return (
    <ChipsInputContainer>
      <Field
        id="file-tags-chips-input"
        name="file_tags"
        source="file_tags"
        //@ts-ignore
        component={ReferenceArrayInput}
        reference="file_tags"
        resource={`file_tags_${tagType}`}
        optionValueField="url"
        renderChildrenBeforeRecord
        fullWidth
        perPage={100}
        filter={{ type: tagType }}
        filterToQuery={(searchText) => ({
          search: searchText,
          // FileTag API only accepts type 'private' | 'public'; global_public uses public tags
          type: tagType,
        })}
        disabled={disabled}
      >
        <ChipsArrayInput
          source="file_tags"
          optionText="title"
          optionValue="url"
          variant="outlined"
          resource="file_tags"
          reference="file_tags"
          trackTagChanges={(changes) => trackTagChanges({ ...changes, trackEvent })}
          disabled={disabled}
        />
      </Field>
    </ChipsInputContainer>
  )
}
